import { Injectable } from '@angular/core';
import { DropdownItem } from '../../models/dropdown-item';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CommonDataHttpService } from './common-data.http-service';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { CommonDataMapper } from './common-data.mapper';
import { State } from '../../models/common-data/state';
import { PioneerUtils } from '../../utils/pioneer-utils';
import { CommonDataStoreInterface } from './common-data.store.interface';
import { Constants } from '../../../shared/constants';
import { Currency } from '../../models/common-data/currency';

@Injectable()
export class CommonDataStore implements CommonDataStoreInterface {

  get commonDataHttpService() { return this._commonDataHttpService; }
  private states$: BehaviorSubject<DropdownItem[]> = new BehaviorSubject([]);
  private countries$: BehaviorSubject<DropdownItem[]> = new BehaviorSubject([]);
  private currencies$: BehaviorSubject<Currency[]> = new BehaviorSubject([]);

  constructor(
    private _commonDataHttpService: CommonDataHttpService,
    private flashMessagesService: FlashMessagesService) { }

  loadCountries(): Observable<DropdownItem[]> {
    return this._commonDataHttpService.getCountries()
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.COULD_NOT_GET_COUNTRIES',
          `Error retrieving countries: ${error}`
        );
        return Observable.throw(error);
      })
      .map(countries => CommonDataMapper.convertCountriesToDropDownItem(countries))
      .map((countries: DropdownItem[]) => {
        this.countries$.next(countries);
        return countries;
      });
  }

  loadStatesFromCountry(countryCode: string): Observable<DropdownItem[]> {
    return this.getStatesFromCountry(countryCode)
      .map(states => CommonDataMapper.convertStatesToDropDownItem(states))
      .map(states => {
        PioneerUtils.orderDropdownByValue(states);
        this.states$.next(states);
        return states;
      });
  }

  get states(): Observable<DropdownItem[]> {
    return this.states$.asObservable();
  }

  get countries(): Observable<DropdownItem[]> {
    return this.countries$.asObservable();
  }

  getCountry(countryCode: string) {
      return this.countries$.flatMap((countries) => {
        return countries.filter(country => country.key === countryCode);
      });
  }

  getState(countryCode, stateCode: string): Observable<DropdownItem> {
    return this.getStatesFromCountry(countryCode)
      .flatMap((states) => {
        return states.filter(state => PioneerUtils.safeTrim(state.stateCode) === stateCode);
      })
      .map(state => CommonDataMapper.convertStateToDropDownItem(state));
  }

  private getStatesFromCountry(countryCode: string): Observable<State[]> {
    if (!countryCode || (Constants.COUNTRIES_WITH_STATES.indexOf(countryCode) < 0)) {
      return Observable.of([]);
    } else {
      return this._commonDataHttpService.getStates(countryCode)
        .catch((error: any) => {
          this.flashMessagesService.error(
            'MESSAGES.ERROR.COULD_NOT_GET_STATES',
            `Error retrieving states: ${error}`
          );
          return Observable.throw(error);
        });
    }
  }

  loadCurrencies(): Observable<Currency[]> {
    return this._commonDataHttpService.getCurrencies()
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.COULD_NOT_GET_CURRENCIES',
          `Error retrieving currencies: ${error}`
        );
        return Observable.throw(error);
      })
      .map((currencies: Currency[]) => {
        this.currencies$.next(currencies);
        return currencies;
      });
  }

  get currencies(): Observable<Currency[]> {
    return this.currencies$.asObservable();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/common-data/common-data.store.ts